import React from 'react';
import PropTypes from 'prop-types';

import {
  getShelfLifeTitle,
} from '[theme-lib]/apps/fops/components/fopPartials/getShelfLifeTitle';

import { formatShelfLife, isInDays } from 'apps/products/utils/shelfLife';

const PackInfoShelfLife = ({ packInfo, className = 'fop-life' }) => {
  if (!packInfo || !packInfo.minimumShelfLife) {
    return null;
  }
  const { minimumShelfLife, averageShelfLife } = packInfo;

  let plus = '+';
  if (isInDays(minimumShelfLife) && (!averageShelfLife || averageShelfLife < minimumShelfLife)) {
    plus = '';
  }

  return (
    <span
      className={className}
      {...(className === 'bop-shelfLife' || className === 'fop-life'
        ? { 'data-title': getShelfLifeTitle(minimumShelfLife, averageShelfLife) }
        : {})}
    >
      {formatShelfLife(minimumShelfLife, 'long')}{plus}
    </span>
  );
};

PackInfoShelfLife.propTypes = {
  packInfo: PropTypes.shape({
    minimumShelfLife: PropTypes.number,
    averageShelfLife: PropTypes.number,
  }),
  className: PropTypes.string,
};

export default PackInfoShelfLife;
